module.exports = __webpack_public_path__ + "img/product_82.d180196.webp";